import * as Yup from 'yup'
import i18n from 'i18n'
import { initialState } from '@/state/sports-ro-calculator'

/**
 * ======================================
 * F O R M   V A L U E S
 * ======================================
 */

export type FormValuesSportsRO = {
  username: string
  startDate: string
  endDate: string
  sports: string[]
  wagerTypes: string[]
  minLine: string
  maxLine: string
  rolloverAmountCalculation: string
}

/**
 * ======================================
 * I N I T I A L   V A L U E S
 * ======================================
 */

export const initialValuesSportsRO: FormValuesSportsRO = {
  username: '',
  startDate: null,
  endDate: null,
  sports: initialState.filters.sports,
  wagerTypes: initialState.filters.wagerTypes,
  minLine: '',
  maxLine: '',
  rolloverAmountCalculation: '',
}

/**
 * ======================================
 * V A L I D A T I O N S   S C H E M A S
 * ======================================
 */

const requiredString = Yup.string().required(i18n.t('error.requiredField'))

export const validationSchemaSportsRO = Yup.object().shape({
  username: requiredString,
  startDate: requiredString,
  endDate: requiredString,
})
